export function runInBackground(
    promise: Promise<unknown> | void,
    onError: (err: unknown) => void
): void {
    if (promise == null) {
        return;
    }
    promise.catch(onError);
}
